// Frontend-only subscription experience. API enforcement remains a separate backend concern.
export const SUBSCRIPTION_RESTRICTED_SECTIONS = new Set([
  "sales", "quatations", "discount", "subscriptions", "draft", "sell_return",
  "items", "item-explore-display", "add-new-item", "edit-item-display",
  "services", "imports", "price_groups", "units", "brands", "categories",
  "taxrate", "variations", "orders", "recieves", "returns", "deliveries",
  "transfers", "openingstock", "reconciliation", "adjusment", "product_services",
  "expenses", "expense_category", "invoicing", "production", "place-new-order",
  "purchase-order-preview", "users", "Staff",
]);

export function getSubscriptionAccess(subscription, now = Date.now()) {
  const expiry = Date.parse(subscription?.expiryDate);
  const status = String(subscription?.status || "").trim().toUpperCase();
  const blockedStatus = ["EXPIRED", "INACTIVE", "SUSPENDED", "CANCELLED", "CANCELED", "UNPAID", "PAST_DUE"].includes(status);
  const validDate = Number.isFinite(expiry);
  const active = validDate && expiry > now && !blockedStatus;
  const remainingDays = validDate ? Math.max(0, Math.ceil((expiry - now) / 86400000)) : null;
  const state = blockedStatus || validDate && expiry <= now ? "expired" : !validDate ? "unknown" : remainingDays <= 3 ? "expiring" : "active";
  return { active, state, remainingDays, expiryDate: subscription?.expiryDate || null };
}

export const isSubscriptionSectionRestricted = section => SUBSCRIPTION_RESTRICTED_SECTIONS.has(section);
